module.exports = __webpack_public_path__ + "static/media/turn-gate.18e3af0f.png";